import React from 'react';
import classes from './dropbtn.module.css';
import { useTranslation } from 'react-i18next';

const Dropbtn = () => {
  const { i18n } = useTranslation();

  const handleChange = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <div className={classes.dropbtn}>
      <select
        onChange={handleChange}
        value={i18n.language}
        className={classes.select}
      >
        <option className={classes.option} value="en">
          English
        </option>
        <option className={classes.option} value="zh">
          简体
        </option>
        <option className={classes.option} value="zh-Hant">
          繁體
        </option>
      </select>
    </div>
  );
};

export default Dropbtn;
